import * as tippy from 'tippy.js';
global.tippy = tippy.default;
import 'tippy.js/dist/tippy.css';
import 'tippy.js/themes/material.css';
import 'tippy.js/themes/light.css';
import '@fortawesome/fontawesome-free/css/all';
import 'tippy.js/animations/shift-away.css';